import { useAuth } from '../context/AuthContext';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Mail, Phone, User, Handshake, ShieldCheck } from 'lucide-react';

export default function ClienteProfiloPage() {
  const { user } = useAuth();

  const isInbound = !!user?.convenzione_id;

  return (
    <div className="max-w-3xl mx-auto space-y-6 pb-8" data-testid="cliente-profilo-page">
      <div>
        <h1 className="text-2xl font-bold text-slate-800" style={{ fontFamily: 'Plus Jakarta Sans' }}>
          Il Mio Profilo
        </h1>
        <p className="text-sm text-slate-500 mt-1">
          Panoramica dei tuoi dati di accesso e del canale di appartenenza.
        </p>
      </div>

      <Card data-testid="profile-summary-card">
        <CardHeader className="pb-3">
          <CardTitle className="text-base flex items-center gap-2">
            <User className="w-5 h-5 text-slate-600" />
            Dati Account
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          <div className="flex items-center gap-3">
            <div className="w-14 h-14 rounded-full bg-emerald-100 flex items-center justify-center text-emerald-700 font-semibold text-xl">
              {(user?.name || user?.email || '?').charAt(0).toUpperCase()}
            </div>
            <div>
              <p className="font-semibold text-slate-800 text-lg">{user?.name || user?.email}</p>
              {isInbound ? (
                <Badge className="bg-emerald-100 text-emerald-800 mt-1 gap-1" data-testid="badge-inbound">
                  <Handshake className="w-3 h-3" />
                  Convenzione: {user.convenzione_nome}
                </Badge>
              ) : (
                <Badge className="bg-slate-100 text-slate-700 mt-1 gap-1" data-testid="badge-outbound">
                  <ShieldCheck className="w-3 h-3" />
                  Cliente Sede
                </Badge>
              )}
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-3 border-t border-slate-100">
            <div className="flex items-center gap-2 text-sm text-slate-700">
              <Mail className="w-4 h-4 text-slate-400" />
              <span className="truncate">{user?.email}</span>
            </div>
            {user?.telefono && (
              <div className="flex items-center gap-2 text-sm text-slate-700">
                <Phone className="w-4 h-4 text-slate-400" />
                {user.telefono}
              </div>
            )}
          </div>

          <div className="text-xs text-slate-400 pt-3 border-t border-slate-100">
            Per modifiche ai tuoi dati anagrafici, contatta il tuo consulente di riferimento
            dalla pagina "Contatti Utili".
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
